"use client"

import { FollowButton, MessageButton } from "@/components/Atoms/Buttons/ColorButtons"
import AvatarImage from "@/components/Molecules/AvatarImage"
import { getEntityLocationStr, humanizeString } from "@/utils/frontend/stringOps"
import Link from "next/link"
import { useUser } from "@/contexts/UserContext"
import { useEffect, useState } from "react"
import Alert from "@/components/Atoms/Alerts/Alert"
import { getData } from "@/utils/frontend/dataOps"
import {useRouter} from 'next/navigation'

const BusinessCard = ({user, data, lang='en', baseUrl='https://talnet.co', avatarSize='lg', showUserUrls=true, userFullNameTextSize='text-xl', userLocationLabelSize='text-sm', showUserSectorIndustry=true, avatarIsClickable=false, nameIsClickable=false, showFollowButton=true, showMessageButton=true, 
  recordType='USER'
}) => {

  
    // console.log('user@businessCard', user)
    // console.log('data@businessCard', data)
    //  let userProfile = data // user profile
    const userProfile = data?.data ?? data

    //  const user = useUser() // authenticated user
    //  const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';

     const router = useRouter()

     const [success, setSuccess] = useState(false)
     const [error, setError] = useState(false)
     const [loading, setLoading] = useState(false)
     const [followedByMe, setFollowedByMe] = useState(false)
    const [followsMe, setFollowsMe] = useState(false)

     const urlsPresent = (showUserUrls === true && recordType === 'USER') ? 
     Object.values(userProfile.user_urls).some(value => value !== null) : 
     (showUserUrls === true && recordType === 'ORGANIZATION') ? 
     Object.values(userProfile.organization_urls).some(value => value !== null) : 
     false // 1. we do ml-8 if so. 2. If showUserUrls is NOT TRUE, we set urlsPresent to false
     




    /*===================================================================
    ---Normalizing values to fit both organization and user recordType
    ====================================================================*/
    let recordUrlsObj = {}, recordFullName = '', recordLocationLabel = '', recordIndustriesArr = [], recordHandle;

    if (recordType === 'USER') {
      recordUrlsObj = userProfile.user_urls
      recordLocationLabel = userProfile.user_location?.label
      recordFullName = `${userProfile.user_first_name} ${userProfile.user_last_name}`
      recordIndustriesArr = userProfile.user_sector_industry
      recordHandle = userProfile.user_handle
    }
    else if (recordType === 'ORGANIZATION') {
      recordUrlsObj = userProfile.organization_urls
      recordLocationLabel = userProfile.organization_location?.label
      recordFullName = `${userProfile.organization_name}`
      recordIndustriesArr = userProfile.organization_sector_industry
      recordHandle = userProfile.organization_handle
    }

    //  recordUrlsObj = recordType === 'USER' ? 
    //  userProfile.user_urls :
    //  recordType === 'ORGANIZATION' ?
    //  userProfile.organization_urls : 
    //  {}




     const getFollowing = async () => { //(await cookies()).toString()
           const data = await getData(`social/follows?filter=true&user_profile_uuid=${recordType === 'USER' ? userProfile.user_uuid : userProfile.organization_uuid}&user_type=${user?.user_type}`, undefined, 'include', undefined, undefined , 'getFollowing@handle@businessCard')
          //  console.log('data@getFollowing', data)
           return data.data
     }

    const handleFollow = async () => {
    
      setLoading(true)
        try {
          let apiUrl = `/api/social/follows/?user_type=${user.user_type}`
          let response = await fetch(apiUrl, {
               method: `POST`, // Use uppercase for HTTP methods
               headers: {
               'Accept': '*/*',
               'Content-Type': 'application/json'
               },
               credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
               body: JSON.stringify({data: {followed_user_uuid: recordType === 'USER' ? userProfile.user_uuid : userProfile.organization_uuid, followed_record_type: recordType}, 
               // tags: {LEVEL_1: selectedLevel1Tags, LEVEL_2: selectedLevel2Tags, LEVEL_3: selectedLevel3Tags}, 
               user: user
               }), // Convert the credentials object to a JSON string
               // body: data
        });

        response = await response.json()
        // console.log('handleSubmitResponse', response)

      if (response.success === true ) {
        // setSuccess({message: `${humanizeString(recordType)} followed`})
        setLoading(false)
        setFollowedByMe(true)
        // callback({refreshData: true})
        // callback({resetTarget: true})

      }
      else { 
        setError({message: `Could not follow user. Error: ${response.message}`})
        setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
            setError({message: `Could not follow user. Error: ${error}`})
          setLoading(false)
        }
    };

    const handleDeleteFollow = async () => {
      setLoading(true)
        try {
      //    ?id=${target.id}
      let apiUrl = `/api/social/follows/${recordType === 'USER' ? userProfile.user_uuid : userProfile.organization_uuid}?user_type=${user.user_type}`
      

            let response = await fetch(apiUrl, {
            method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
            headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json'
            },
            credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
            // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
            // body: data
          });

          response = await response.json()
          console.log('handleDeleteResponse', response)
        if (response.success === true ) {
          // setSuccess({message: 'The post has been deleted.'})

          setLoading(false)
            setFollowedByMe(false)
        }
        else { 
          setError({message: 'There was a problem unfollowing user'})
          setLoading(false)
        }
        // callback({refreshData: true})

              
          } catch (error) {
            console.log('error', error)
            setLoading(false)
          }
    }

  useEffect(() => {
    const init = async () => {
     const following = await getFollowing()
    //  console.log("FOLLOWING", following)
     setFollowedByMe(await following?.[0].followed_by_me)
     setFollowsMe(await following?.[0].follows_me)
    }
    init()
  }, [])
  
     return (<div className=""> 
      <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
          <div className="mt-2 flex mx-auto items-center">
               {showUserUrls === true && <span className="space-y-1">
               {recordUrlsObj.website_url && 
               <div>
               <Link href={`https://${recordUrlsObj.website_url}?utm_source=talnet.co`} rel="nofollow noopener noreferrer" target="_blank">
               <img src={`${baseUrl}/icons/sm-icons/website.png`} className="social-icons-3"/>
               </Link>
               </div>
               }
               {recordUrlsObj.linkedin_url && 
               <div>
               <Link href={`https://${recordUrlsObj.linkedin_url}`} rel="nofollow noopener noreferrer" target="_blank">
               <img src={`${baseUrl}/icons/sm-icons/linkedin.png`} className="social-icons-3"/>
               </Link>
               </div>
               }
               {recordUrlsObj.twitter_url &&
               <div>
               <Link href={`https://${recordUrlsObj.twitter_url}`} rel="nofollow noopener noreferrer" target="_blank">
               <img src={`${baseUrl}/icons/sm-icons/twitter.png`} className="social-icons-3"/>
               </Link>
               </div>
               }
               {recordUrlsObj.facebook_url && 
                    <div>
               <Link href={`https://${recordUrlsObj.facebook_url}`} rel="nofollow noopener noreferrer" target="_blank">
               <img src={`${baseUrl}/icons/sm-icons/facebook.png`} className="social-icons-3"/>
               </Link>
               </div>
               }
               {recordUrlsObj.instagram_url && 
                    <div>
               <Link href={`https://${recordUrlsObj.instagram_url}`} rel="nofollow noopener noreferrer" target="_blank">
               <img src={`${baseUrl}/icons/sm-icons/instagram.png`} className="social-icons-3"/>
               </Link>
               </div>
               }
               </span>}

               {avatarIsClickable?<Link href={`/@${recordHandle}`} className={`mx-auto`}><AvatarImage hoverable={avatarIsClickable} data={userProfile} module={'USER'} size={avatarSize}/></Link>
               :        
               <span className={`mx-auto`}><AvatarImage hoverable={avatarIsClickable} data={userProfile} module={recordType} size={avatarSize}/></span>
               }

               </div>

          <div className={`text-center ${userFullNameTextSize} font-inter font-base dark:text-white font-inter mt-4 ${(urlsPresent && showUserUrls) && 'ml-8'}`}>
            {nameIsClickable ? 
              <Link href={`/@${recordHandle}`} className="hover:underline">
                {humanizeString(recordFullName)}
                </Link> : 
              <>{humanizeString(recordFullName)}</>}

          </div>
          {/* <div className="text-center flex">
          <span className="inline">  <img src="/icons/sm-icons/website.png" className="social-icons-3"/></span>
          <span className="inline">  <img src="/icons/sm-icons/website.png" className="social-icons-3"/></span>
          </div> */}
          {/* {console.log("USA", userProfile)} */}


          <p className={`text-center ${userLocationLabelSize} font-inter dark:text-slate-300 ${(urlsPresent && showUserUrls) && 'ml-8'}`}>
            {/* {getEntityLocationStr('user', userProfile)} */}
            {recordLocationLabel}
            </p>


          {/*--------------------
               USER INDUSTRIES  
          ----------------------*/}
          {(recordIndustriesArr && showUserSectorIndustry) && <div className={`flex gap-1 flex-wrap justify-center text-center text-xs font-inter mt-2 ${(urlsPresent && showUserUrls) && 'ml-8'}`}>
               {recordIndustriesArr.map(x=> 
          
                    <span key={x.id} className="whitespace-nowrap px-2 py-1 border text-slate-500 dark:text-slate-300 rounded border-slate-400 dark:border-slate-600 ">{x[`label_${lang}`]}</span>
               )}
          </div>}


          {/*-----------------------
            Follow + message buttons
          --------------------  ------ */}
    <div className={`flex flex-row flex-wrap gap-2 justify-center w-full items-center mt-4 ${(urlsPresent && showUserUrls) && 'ml-4'}`}>
      <div className="">
         {(showFollowButton===true && user?.user_uuid !== userProfile.user_uuid) && <div>
               <FollowButton 
              //  disabled={false}
              //  disabled={!user || user.user_uuid === userProfile.user_uuid} 
              disabled={user?.user_uuid === userProfile.user_uuid} //
               caption={followedByMe ? 'Following' : followsMe ? 'Follow Back' : 'Follow'}
               hoveringCaption={followedByMe ? 'Unfollow' : followsMe ? 'Follow Back' : 'Follow'} 

               followed={followedByMe} 
               loading={loading}  
              // onClick={followedByMe ? handleDeleteFollow : handleFollow}
               onClick={!user ? ()=> router.push(`/auth/signin`) : followedByMe ? handleDeleteFollow : handleFollow}
              />
          </div>}
          </div>

          <div className="">
         {(showMessageButton===true && user?.user_uuid !== userProfile.user_uuid && followedByMe && followsMe) && <div>
               <MessageButton 
              //  href={`/workspace/chat`}
              href={`/workspace/chat?newChatRecipient=${encodeURIComponent(recordHandle)}`}

              //  disabled={false}
              //  disabled={!user || user.user_uuid === userProfile.user_uuid} 
              disabled={user?.user_uuid === userProfile.user_uuid} //
               caption={'Send Message'}
               hoveringCaption={'Send Message'} 

               followed={followedByMe} 
               loading={loading}  
              // onClick={followedByMe ? handleDeleteFollow : handleFollow}
              //  onClick={!user ? ()=> router.push(`/auth/signin`) : followedByMe ? handleDeleteFollow : handleFollow}
              />
          </div>}
          </div>
          </div>

     </div>)
}

export default BusinessCard